export class StyleBuffer {
  private activeStyles: Record<string, string>;

  constructor(initialStyles: Record<string, string> | StyleBuffer = {}) {
    this.activeStyles = initialStyles instanceof StyleBuffer ? initialStyles.styles : initialStyles;
  }

  get styles(): Record<string, string> {
    return { ...this.activeStyles };
  }

  set styles(styles: Record<string, string>) {
    this.activeStyles = { ...styles };
  }

  get length(): number {
    return Object.keys(this.activeStyles).length;
  }

  merge(updates: Record<string, string> | StyleBuffer): void {
    this.styles = {
      ...this.activeStyles,
      ...(updates instanceof StyleBuffer ? updates.styles : updates),
    };
  }

  delete(...styleKeys: string[]): void {
    styleKeys.forEach((styleKey) => delete this.activeStyles[styleKey]);
  }

  clear(): void {
    this.activeStyles = {};
  }

  toString(): string {
    return Object.entries(this.styles)
      .sort()
      .map(([key, value]) => `${key}: ${value};`)
      .join(' ');
  }

  valueOf(): string {
    return this.toString();
  }
}
